import React from 'react';
import { bool, number, oneOf, string } from 'prop-types';
import classNames from 'classnames';
import css from './Counter.module.css';

const MAX = 99;

/**
 * A count next to a tab, a nav item or an icon (3, 12, 99+), or a dot when there is something new
 * without a number. `primary` takes the family colour (orange public, blue dashboard). The dot is
 * decorative: say what it means in the text next to it.
 */
const Counter = props => {
  const { rootClassName, className, count, tone, dot } = props;
  if (dot) {
    return <span className={classNames(css.dot, css[tone], className)} aria-hidden="true" />;
  }
  const classes = classNames(rootClassName || css.root, css[tone], className);
  return <span className={classes}>{count > MAX ? `${MAX}+` : count}</span>;
};

Counter.defaultProps = {
  rootClassName: null,
  className: null,
  count: 0,
  tone: 'primary',
  dot: false,
};

Counter.propTypes = {
  rootClassName: string,
  className: string,
  count: number,
  tone: oneOf(['primary', 'neutral']),
  dot: bool,
};

export default Counter;
